export const US_STATES = [
  { label: 'AL' },
  { label: 'AK' },
  { label: 'AZ' },
  { label: 'AR' },
  { label: 'AS' },
  { label: 'CA' },
  { label: 'CO' },
  { label: 'CT' },
  { label: 'DE' },
  { label: 'DC' },
  { label: 'FL' },
  { label: 'GA' },
  { label: 'GU' },
  { label: 'HI' },
  { label: 'ID' },
  { label: 'IL' },
  { label: 'IN' },
  { label: 'IA' },
  { label: 'KS' },
  { label: 'KY' },
  { label: 'LA' },
  { label: 'ME' },
  { label: 'MD' },
  { label: 'MA' },
  { label: 'MI' },
  { label: 'MN' },
  { label: 'MS' },
  { label: 'MO' },
  { label: 'MP' },
  { label: 'MT' },
  { label: 'NE' },
  { label: 'NV' },
  { label: 'NH' },
  { label: 'NJ' },
  { label: 'NM' },
  { label: 'NY' },
  { label: 'NC' },
  { label: 'ND' },
  { label: 'OH' },
  { label: 'OK' },
  { label: 'OR' },
  { label: 'PA' },
  { label: 'PR' },
  { label: 'RI' },
  { label: 'SC' },
  { label: 'SD' },
  { label: 'TN' },
  { label: 'TX' },
  { label: 'UT' },
  { label: 'VT' },
  { label: 'VI' },
  { label: 'VA' },
  { label: 'WA' },
  { label: 'WV' },
  { label: 'WI' },
  { label: 'WY' },
];

export const STATE_CODE_TO_NAME: Record<string, string> = {
  AL: 'Alabama',
  AK: 'Alaska',
  AS: 'American Samoa',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District Of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  MP: 'Northern Mariana Islands',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PW: 'Palau',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VI: 'Virgin Islands',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};
